module.exports = __webpack_public_path__ + "static/img/icon2.6fdfc853.png";